import { AxisKey } from "./types";

export interface AxisPresentation {
  color: string;
  iconName: "puzzle" | "book" | "calculator" | "target" | "eye";
}

export const AXIS_PRESENTATION: Record<AxisKey, AxisPresentation> = {
  problemSolving: { color: "blue", iconName: "puzzle" },
  readingProcessingSpeed: { color: "teal", iconName: "book" },
  numericalReasoning: { color: "yellow", iconName: "calculator" },
  attentionSelfControl: { color: "green", iconName: "target" },
  visualTrackingCoordination: { color: "orange", iconName: "eye" },
};
